import { render } from "./ByosSuccess.vue?vue&type=template&id=7d979564"
import script from "./ByosSuccess.vue?vue&type=script&setup=true&lang=js"
export * from "./ByosSuccess.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/byos/ByosSuccess.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7d979564"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7d979564', __exports__)) {
    api.reload('7d979564', __exports__)
  }
  
  module.hot.accept("./ByosSuccess.vue?vue&type=template&id=7d979564", () => {
    api.rerender('7d979564', render)
  })

}


export default __exports__